import { useQuery } from '@tanstack/react-query';
import { formatCents } from '@/components/repairs';
import { Select } from '@/components/ui/primitives';
import { api } from '@/lib/api';

export interface MyRate {
  id: string;
  name: string;
  priceCents: number;
  isDefault: boolean;
}

/** Stundensätze, die der angemeldete Mitarbeiter wählen darf (Vorauswahl zuerst). */
export const useMyRates = () => useQuery({ queryKey: ['hourly-rates', 'mine'], queryFn: () => api<{ items: MyRate[] }>('/hourly-rates/mine'), staleTime: 5 * 60_000 });

/** Auswahl des Stundensatzes; ohne zugeordnete Sätze wird nichts angezeigt. */
export function RateSelect({ value, onChange, className }: { value: string; onChange: (id: string) => void; className?: string }) {
  const { data } = useMyRates();
  const rates = data?.items ?? [];
  if (rates.length === 0) return null;
  return (
    <Select value={value || rates[0]!.id} onChange={(e) => onChange(e.target.value)} aria-label="Stundensatz" className={className}>
      {rates.map((r) => (
        <option key={r.id} value={r.id}>
          {r.name} ({formatCents(r.priceCents)}/h)
        </option>
      ))}
    </Select>
  );
}
